import { DOC_TYPE } from 'config'
import { DocType } from 'entities/Documents'

import GeneralOcrCsvConfigDialog from './GeneralOcrCsvConfigDialog'
import InvoiceOcrBuilderCsvConfigDialog from './InvoiceOcrBuilderCsvConfigDialog'

type Props = {
  docType: DocType
  docTypeName: string
  open: boolean
  actionText?: string
  subGroup?: string
  ocrBuilderConfigID?: number
  onClose: (canceled: boolean) => void
}

export default function CsvConfigDialog({ docType, open, ...rest }: Props) {
  return (
    <>
      <GeneralOcrCsvConfigDialog open={docType === DOC_TYPE.GENERAL_OCR && open} {...rest} />
      <InvoiceOcrBuilderCsvConfigDialog
        docType={docType}
        open={docType !== DOC_TYPE.GENERAL_OCR && open}
        {...rest}
      />
    </>
  )
}
